import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getUserList = store => store[NAME].userList;